import axios from '../../../helpers/custom-axios';
import { notify, confirmation } from '../../../helpers/notifications';

export const handleCreateMailer = async (mailer) => {
  return axios
    .post('manage/mailers', mailer)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleUpdateMailer = async (id, mailer) => {
  return axios
    .put(`manage/mailers/${id}`, mailer)
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const handleCopyMailer = async (id, callback) => {
  confirmation.copy(async () => {
    return axios
      .get(`manage/mailers/${id}/copy`)
      .then((res) => {
        notify.alertSuccess('Success!', 'Mailer copied.');
        callback(res);
      })
      .catch((error) => {
        notify.alertFailure('Uh oh!', 'Something went wrong...');
        callback(error);
      });
  });
};

export const handleDestroyMailer = async (id, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`manage/mailers/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};

// Old way of scanning mailers.  Now the scan result is included in the mailer fetch data
//
// export const scanMailers = async (ids) => {
//   if (ids.length == 0) return [];
//   notify.info('Scanning...', { showOnlyTheLastOne: false });
//   let promises = [];
//   let invalids = [];
//   ids.forEach((id) => {
//     promises.push(
//       axios
//         .get(`manage/mailers/${id}/scan_body`)
//         .then((res) => {
//           const { data } = res;
//           if (data.body_is_invalid) {
//             invalids.push({
//               mailer_id: id,
//               ...data,
//             });
//           }
//         })
//         .catch((err) => {
//           notify.failure('Something went wrong...');
//           console.error(err);
//         })
//     );
//   });
//   return Promise.all(promises).then(() => {
//     if (invalids.length == 0) {
//       notify.success('No issues found!', { showOnlyTheLastOne: false });
//     } else {
//       notify.failure('Mailers Require Attention', {
//         showOnlyTheLastOne: false,
//       });
//     }
//     return invalids;
//   });
// };

export const sendTestMailer = async (path, testData) => {
  return axios
    .get(path, { params: testData })
    .then((res) => {
      if (res.ok)
        notify.alertSuccess(
          'Mailer test queued',
          'Test email should arrive shortly!'
        );
    })
    .catch((error) => {
      notify.failure();
      console.error(error.response);
    });
};

export const createSingleDelivery = async (delivery) => {
  return axios
    .post('/manage/deliveries', { delivery })
    .then((res) => {
      notify.info('Mail Job Queued');
      return res;
    })
    .catch((error) => {
      notify.failure();
      console.error(error?.response);
      if (error?.response?.status === 422) {
        notify.alertFailure('Failed to Send', error.response.data.errors);
      }
      return error;
    });
};

export const handleBatchSend = async (path, params, count) => {
  return axios
    .get(path, { params })
    .then((res) => {
      notify.alertSuccess('Mail Job Queued', `Sending to ${count} recipients.`);
      return res;
    })
    .catch((error) => {
      notify.failure();
      console.error(error.response);
      if (error?.response?.status === 422) {
        notify.alertFailure('Failed to Send', 'Something went wrong...');
      }
      return error;
    });
};
